export default __webpack_public_path__ + "static/media/fetured-item-3.70f33a3b.png";